var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product"},[_c('el-tabs',{attrs:{"type":"card"},model:{value:(_vm.tabsKey),callback:function ($$v) {_vm.tabsKey=$$v},expression:"tabsKey"}},[_c('el-tab-pane',{attrs:{"label":"商品","name":"product"}},[_c('products')],1),_c('el-tab-pane',{attrs:{"label":"系列別","name":"class"}},[_c('classSearch')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }